import { dataService } from '../../data';

import { DataObject, ObjectOptions } from '../base';
import { CreateObject } from '../item';

import { PlaceType } from '../types';
import { PaymentType } from '../types';

/**
 * Central SWINVOICE: Gekkotech license fiscal invoice (not place TICKETBAI/VERIFACTU).
 * Synced to the POS via PAYMENT.swinvoice (tenant → global), same pattern as QRCODE → QRSCAN.
 */
const _schema = {
    name: 'SWINVOICE',
    fields: [
        { name: 'place', type: 'objid' },
        { name: 'payment', type: 'objid' },
        { name: 'series', type: 'string' },
        { name: 'number', type: 'number' },
        { name: 'issued', type: 'date' },
        { name: 'amount', type: 'number' },
        { name: 'taxrate', type: 'number' },
        { name: 'agency', type: 'string' },
        { name: 'region', type: 'string' },
        { name: 'id', type: 'string' },
        { name: 'qr', type: 'string' },
        { name: 'error', type: 'string' },
        { name: 'sent', type: 'date' },
        { name: 'valid', type: 'string' },
    ],
    relate: [
        { direction: '>', target: 'PLACE', by: 'place', name: 'place', reason: 'place', child: false, class: PlaceType },
        { direction: '>', target: 'PAYMENT', by: 'payment', name: 'payment', reason: 'payment', child: false, class: PaymentType },
    ],
} as const;

const _SwinvoiceClass = CreateObject(_schema);
if (!_SwinvoiceClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

export class Swinvoice extends _SwinvoiceClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null) {
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Swinvoice {
        return this._Copy(store) as Swinvoice;
    }
}
